enum MotionEasings {
	EaseIn = 'ease-in',
	EaseOut = 'ease-out',
}

export default MotionEasings;
